import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const UpdateDetails = () => {
  // Get the state data (bookingDetails) from the location
  const location = useLocation();
  const { bookingDetails } = location.state || {}; // Fallback to empty object if state is not available

  return (
    <div className="h-[600px] max-w-6xl mx-auto px-6 pt-20 md:pt-1 flex flex-col justify-center items-center">
      {/* Reservation Heading */}
      <div className="text-center mb-8 md:mb-10">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
          Manage Your Booking & Room Upgrade
        </h2>
        <p className="text-gray-500 text-xs sm:text-base">
          Choose an option below to either reschedule your booking or upgrade your room.
        </p>
      </div>

      <div className="w-full max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 justify-items-center">
          {/* Reschedule Booking Card */}
          <div className="flex flex-col items-center justify-center text-center max-w-md p-6 bg-gray-200 text-black rounded-md shadow-md">
            <h3 className="text-lg md:text-xl font-bold mt-2">Reschedule Booking</h3>
            <p className="text-sm mt-3 mb-4 text-gray-600">
              Adjust your check-out date to extend or shorten your stay. Whether you need additional
              time to unwind or plan to leave sooner, we’ll help you modify your schedule with ease.
            </p>
            <Link
              to="/reservation/options/update-checkout-date"
              state={{ bookingDetails }} // Pass bookingDetails to the next route
              className="px-8 py-2 sm:px-10 sm:py-3 bg-cyan-500 rounded-md text-white hover:text-black transition text-sm sm:text-base"
            >
              Reschedule
            </Link>
          </div>

          {/* Room Upgrade Card */}
          <div className="flex flex-col items-center justify-center text-center max-w-md p-6 bg-gray-200 text-black rounded-md shadow-md">
            <h3 className="text-lg md:text-xl font-bold mb-2">Room Upgrade</h3>
            <p className="text-sm mt-3 mb-4 text-gray-600">
              Enhance your experience by upgrading your room. Choose from our premium options to
              enjoy additional comfort and luxury.
            </p>
            <Link
              to="/reservation/options/update-room-type"
              state={{ bookingDetails }} // Pass bookingDetails to the next route
              className="mt-3 px-8 py-2 sm:px-10 sm:py-3 bg-cyan-500 rounded-md text-white hover:text-black transition text-sm sm:text-base"
            >
              Upgrade
            </Link>
          </div>
          <div className="flex flex-col items-center justify-center text-center max-w-md p-6 bg-gray-200 text-black rounded-md shadow-md">
            <h3 className="text-lg md:text-xl font-bold mt-2">Amenities</h3>
            <p className="text-sm mt-3 mb-4 text-gray-600">
              Enjoy a luxurious stay with modern amenities, including well-appointed rooms,
              high-speed Wi-Fi, a fitness center, a swimming pool, and on-site dining options.
            </p>
            <Link
              to="/reservation/options/amenities/order-meal"
              state={{ bookingDetails }} // Pass bookingDetails to the next route
              className="px-8 py-2 sm:px-10 sm:py-3 bg-cyan-500 rounded-md text-white hover:text-black transition text-sm sm:text-base"
            >
              Add Services
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateDetails;
